
































import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import { RandomizerButton } from '../../index'

@Component
export default class PercentChanger extends Vue {
  @Prop() button!: RandomizerButton

  @Prop() disabled!: boolean

  @Prop() freePercents!: number

  handleKeyDown(e: KeyboardEvent): void {
    if (!/\d/.test(e.key)) {
      e.preventDefault()
    }
  }

  @Emit()
  setPercent(percent: number): number {
    return percent
  }

  @Emit()
  remove(): number {
    return this.button.output
  }
}
